import { SlidersHorizontal, TrendingUp, Users } from "lucide-react";
import { Reveal, SectionHead } from "./shared";

const PRINCIPLES = [
    {
        icon: Users,
        title: "Human When It Matters",
        desc: "The AI handles routine conversations and knows when to hand the conversation to a real person.",
    },
    {
        icon: SlidersHorizontal,
        title: "Built Around Your Business",
        desc: "Your workflows, services, rules, and communication style.",
    },
    {
        icon: TrendingUp,
        title: "Always Improving",
        desc: "Your automation can evolve as your business grows.",
    },
];

export default function Trust() {
    return (
        <section className="py-24 sm:py-32" data-testid="trust-section">
            <div className="container-x">
                <SectionHead
                    eyebrow="09 — Our Promise"
                    title="Automation Should Make Your Business Better — Not More Complicated."
                    testid="trust-heading"
                />
                <div className="mt-16 grid md:grid-cols-3 gap-5">
                    {PRINCIPLES.map((p, i) => (
                        <Reveal key={p.title} delay={i * 0.1}>
                            <div className="glass card-hover rounded-3xl p-8 h-full" data-testid={`trust-card-${i + 1}`}>
                                <div className="w-12 h-12 rounded-2xl bg-cyan-400/10 border border-cyan-400/25 flex items-center justify-center">
                                    <p.icon className="w-5 h-5 text-cyan-300" />
                                </div>
                                <h3 className="mt-6 text-xl font-bold text-white tracking-tight">{p.title}</h3>
                                <p className="mt-3 text-sm text-slate-400 leading-relaxed">{p.desc}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
